import { isTimeValid } from '@components/input-time/src/utils/is-time-valid';

export const getTimeFormatted = (prevValue: string, newValue: string): string => {
  if (!isTimeValid(newValue)) {
    return '';
  }

  if (newValue.length === 2 && prevValue.length !== 3 && !newValue.includes(':')) {
    newValue = `${newValue}:`;
  }

  return newValue;
};
